import moment from 'moment';
/*
 * Returns current date initialized by midnight
 * @type {Date}
 */
export const getCurrentDate00am = (): Date => {
	const date = new Date();
	date.setHours(0, 0, 0, 0);
	return date;
};
/*
 * Returns date from given string, initialized by midnight
 * @type {Date}
 */
export const getDateFromString = (dateString: string): Date => {
	const date = new Date(dateString);
	date.setHours(0, 0, 0, 0);
	return date;
};
/*
 * Returns Date width adjusted year, refered to today.
 * e.g. getDateWidthAdjustedYear(-5) returns todays Date but 5 years ago.
 *
 * @param  {number} yearsToAdjust [description]
 * @return {Date}               [description]
 */
export const getDateWidthAdjustedYear = (yearsToAdjust: number): Date => {
	const date = getCurrentDate00am();
	date.setFullYear(date.getFullYear() + yearsToAdjust);
	return date;
};
/*
 *  Return date in format yyyy-mm-dd
 * @param date
 * @returns {*}
 * @private
 */
export const transformDateToIso8601 = (date: Date): string => {
	function pad(num) {
		if (num < 10) {
			return `0${num}`;
		}
		return num;
	}

	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};
/*
 *  Return date in format dd
 * @returns {*}
 * @private
 */
export const getTodayDayOfMonth = (): string => {
	return moment().format('DD');
};
/*
 *  Return date in format dd
 * @returns {*}
 * @private
 */
export const getNativeFromInternalDate = (dateString: string): string => {
	return moment(dateString, 'DD.MM.YYYY').format('YYYY-MM-DD');
};
/*
 *  Return date in format dd
 * @returns {*}
 * @private
 */
export const getInternalFromNativeDate = (dateString: string): string => {
	return moment(dateString, 'YYYY-MM-DD').format('DD.MM.YYYY');
};

export default {
	getCurrentDate00am,
	getDateFromString,
	getDateWidthAdjustedYear,
	transformDateToIso8601,
};
